import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ApiService from "../../ApiService";
import { Container, Row, Badge, Col, ListGroup, Card } from "react-bootstrap";
import removeClass from "../../util/RemoveCSS";
import { IoSend, IoPersonAdd } from "react-icons/io5";
import { IoIosCreate } from "react-icons/io";
import { TfiReload } from "react-icons/tfi";
import PageTitle from "../Common/PageTitle/PageTitle";
import { isAuditorReadOnlyRole, isSuperAdminRole } from "../../util/authUtil";
import CreateOrder from "./CreateOrder";
import CreatePrepOrder from "./CreatePrepOrder";
import UploadResults from "./UploadResults";
import ManagePrepEnrollment from "./ManagePrepEnrollment";

export const PAGES = {
  CREATE_ORDER: "CreateOrder",
  CREATE_PREP_ORDER: "CreatePrepOrder",
  UPLOAD_RESULTS: "UploadResults",
  MANAGE_PREP_ENROLLMENT: "ManagePrepEnrollment"
};

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const SuperAdminPanel = () => {
  const [view, setView] = useState(null);
  const query = useQuery();

  const resetView = () => {
    setView(null);
    window.history.pushState({}, "", "/super-admin");
  };

  useEffect(() => {
    const pageParam = query.get("page");
    if (
      pageParam === PAGES.CREATE_ORDER ||
      pageParam === PAGES.CREATE_PREP_ORDER ||
      pageParam === PAGES.UPLOAD_RESULTS ||
      pageParam === PAGES.MANAGE_PREP_ENROLLMENT
    ) {
      setView(pageParam);
    }
    // eslint-disable-next-line
  }, []);

  if (view === PAGES.CREATE_ORDER) return <CreateOrder resetView={resetView} />;

  if (view === PAGES.CREATE_PREP_ORDER) return <CreatePrepOrder resetView={resetView} />;

  if (view === PAGES.UPLOAD_RESULTS) return <UploadResults resetView={resetView} />;

  const navigateToCreatePrepOrder = (params) => {
    const q = new URLSearchParams({ page: PAGES.CREATE_PREP_ORDER, ...params });
    window.history.pushState({}, "", `/super-admin?${q.toString()}`);
    setView(PAGES.CREATE_PREP_ORDER);
  };
  if (view === PAGES.MANAGE_PREP_ENROLLMENT) return <ManagePrepEnrollment resetView={resetView} onNavigateToCreatePrepOrder={navigateToCreatePrepOrder} />;

  return (
    <Container fluid>
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2 style={{ fontSize: "24px", fontWeight: "600", color: "black" }}>SUPER ADMIN PANEL</h2>
        <p style={{ color: "#555", fontSize: "1rem", marginTop: "8px" }}>
          Use the options below to manage your system. Click “Create an Order on Saleor” to begin, or select any feature (currently inactive) for
          future functionality.
        </p>
      </div>
      <Row className="g-4 mt-4">
        {/* Active: Create Order */}
        <Col md={3}>
          <Card
            onClick={() => setView(PAGES.CREATE_ORDER)}
            style={{
              background: "white",
              border: "1px solid #ddd",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease",
              height: "275px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.07)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.boxShadow = "0 2px 12px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div
              style={{
                background: "rgba(0, 127, 97, 0.1)",
                borderRadius: "50%",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px"
              }}
            >
              <IoIosCreate size={32} color="#007F61" />
            </div>
            <Card.Title
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#333",
                textAlign: "center"
              }}
            >
              Create a Kit Order
            </Card.Title>
          </Card>
        </Col>

        <Col md={3}>
          <Card
            onClick={() => setView(PAGES.CREATE_PREP_ORDER)}
            style={{
              background: "white",
              border: "1px solid #ddd",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease",
              height: "275px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.07)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.boxShadow = "0 2px 12px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div
              style={{
                background: "rgba(239, 129, 86, 0.1)",
                borderRadius: "50%",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px"
              }}
            >
              <IoIosCreate size={32} color="#EF8156" />
            </div>
            <Card.Title
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#333",
                textAlign: "center"
              }}
            >
              Create a PrEP Order
            </Card.Title>
          </Card>
        </Col>

        <Col md={3}>
          <Card
            onClick={() => setView(PAGES.UPLOAD_RESULTS)}
            style={{
              borderRadius: "12px",
              border: "1px solid #eee",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.03)",
              background: "white",
              cursor: "pointer",
              height: "275px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div
              style={{
                background: "rgba(0, 127, 97, 0.1)",
                borderRadius: "50%",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px"
              }}
            >
              <IoSend size={32} color="#007F61" />
            </div>
            <Card.Title
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#666",
                textAlign: "center"
              }}
            >
              Upload Results
            </Card.Title>
          </Card>
        </Col>

        <Col md={3}>
          <Card
            onClick={() => setView(PAGES.MANAGE_PREP_ENROLLMENT)}
            style={{
              background: "white",
              border: "1px solid #ddd",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease",
              height: "275px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.07)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.boxShadow = "0 2px 12px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div
              style={{
                background: "rgba(99, 102, 241, 0.1)",
                borderRadius: "50%",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px"
              }}
            >
              <IoPersonAdd size={32} color="#6366f1" />
            </div>
            <Card.Title
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#333",
                textAlign: "center"
              }}
            >
              Manage PrEP Enrollment
            </Card.Title>
          </Card>
        </Col>

        {/* Inactive: Register Kit for Patient */}
        <Col md={3}>
          <Card
            style={{
              borderRadius: "12px",
              border: "1px solid #eee",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.03)",
              background: "white",
              cursor: "not-allowed",
              opacity: 0.5,
              height: "275px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div
              style={{
                background: "rgba(204, 204, 204, 0.3)",
                borderRadius: "50%",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px"
              }}
            >
              <TfiReload size={32} color="#bbb" />
            </div>
            <Card.Title
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#bbb",
                textAlign: "center"
              }}
            >
              Register Kit for Patient
            </Card.Title>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default SuperAdminPanel;
